<template>
  <Listbox v-model="selected_item" as="div">
    <div class="mt-1 flex rounded-md shadow-sm">
      <div class="relative flex items-stretch flex-grow focus-within:z-10">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </div>
        <input
          v-model="search_term"
          :disabled="disabled"
          autocomplete="off"
          :placeholder="$t('Add option')"
          type="text"
          class="focus:ring-blue focus:border-blue-light block w-full disabled:bg-gray-200 rounded-md pl-10 sm:text-sm border-gray-300 dark:bg-dark-box-background dark:border-dark-divider-border font-normal text-gray-900 dark:text-white"
          @click="show_results = true"
          @keydown="handleKeyDown"
          @blur="
            () => {
              show_results = false
            }
          ">
      </div>
    </div>

    <transition
      v-show="
        show_results &&
          data.filter((v) => !selected_items.includes(v)).filter((s) => s?.label?.includes(search_term) || s?.includes(search_term)).length >
          0
      "
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <ListboxOptions
        id="user-panel"
        static
        class="absolute mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm dark:bg-dark-box-background z-20">
        <ListboxOption
          v-for="item in data
            .filter((v) => !selected_items.includes(v))
            .filter((s) => s?.label?.includes(search_term) || s?.includes(search_term))"
          :key="item.id"
          as="template"
          :value="item?.value ? item?.value : item">
          <li class="text-gray-900 cursor-pointer hover:bg-gray-200 relative py-2 pl-8 pr-4 dark:text-white dark:hover:bg-transparent">
            <div class="flex justify-between items-center">
              <span :class="['font-normal ml-3 block ']">
                {{ item?.label ? item?.label : item }}
              </span>
              <span class="ml-6" @click.prevent="handleDelete(item)">{{ $t("Delete") }}</span>
            </div>
          </li>
        </ListboxOption>
      </ListboxOptions>
    </transition>
    <div class="flex flex-row gap-2 mt-1 flex-wrap overflow-y-auto max-h-32">
      <draggable
        v-model="selected_items"
        v-bind="{
          animation: 200,
          group: 'options',
          ghostClass: 'ghost',
          chosenClass: 'chosen'
        }"
        :class="[
          selected_items.length ? 'border border-gray-300' : '',
          'flex w-full flex-col dark:bg-dark-box-background dark:text-white  bg-white rounded-md shadow-sm focus:outline-none sm:text-sm'
        ]"
        item-key="id">
        <template #item="{ element, index }">
          <div
            class="group w-full px-2 flex dark:text-white justify-between just pl-3 py-2 rounded-md text-left focus:outline-none sm:text-sm hover:opacity-75"
            :class="$store.state.ui.currentPage == 'companyprofile' ? 'hover:bg-blue' : ''">
            <template v-if="type == 'checklist'">
              <div class="flex flex-row items-center justify-center">
                <div class="flex flex-col justify-center text-blue">
                  <CircleCheck
                    :class="[$store.state.ui.currentPage == 'companyprofile' ? 'group-hover:text-white' : '', 'font-bold h-5 w-5']"
                    aria-hidden="true" />
                </div>
                <span
                  :class="[$store.state.ui.currentPage == 'companyprofile' ? 'group-hover:text-white' : '', 'ml-3 block text-gray-800']">{{ element }}</span>
              </div>
              <span class="h-full" />
            </template>
            <template v-else-if="type == 'bulletpointslist'">
              <div class="flex flex-row justify-center">
                <div class="flex flex-col justify-center">
                  <div class="group-hover:text-white bg-dark-box-background dark:bg-white w-2 h-2 rounded-full" />
                </div>
                <span
                  :class="[$store.state.ui.currentPage == 'companyprofile' ? 'group-hover:text-white' : '', 'ml-3 block text-gray-800']">{{ element }}</span>
              </div>
              <span class="h-full" />
            </template>
            <template v-else>
              <div class="flex flex-row justify-center">
                <div class="flex flex-col justify-center">
                  <span
                    :class="[$store.state.ui.currentPage == 'companyprofile' ? 'group-hover:text-white' : '', 'font-bold text-blue -mt-1']">{{ index + 1 }}.
                  </span>
                </div>
                <span
                  :class="[$store.state.ui.currentPage == 'companyprofile' ? 'group-hover:text-white' : '', 'ml-3 block text-gray-800']">{{ element }}</span>
              </div>
              <span class="h-full" />
            </template>
            <button
              class="opacity-0 group-hover:opacity-100 ml-5 w-6 h-6 float-left inset-y-0 right-0 items-center rounded-full justify-center flex group hover:bg-red-400"
              type="button"
              @click="deselectItem(index)">
              <X
                :class="[
                  $store.state.ui.currentPage == 'companyprofile' ? 'text-white' : 'text-gray-700',
                  'h-5 w-5 hover:text-white group-hover:cursor-pointer'
                ]"
                aria-hidden="true" />
            </button>
          </div>
        </template>
      </draggable>
    </div>
  </Listbox>
</template>

<script>
import draggable from "vuedraggable"
import { Listbox, ListboxOption, ListboxOptions } from "@headlessui/vue"
import { Search, X, CircleCheck } from "lucide-vue-next"
export default {
  components: {
    draggable,
    CircleCheck,
    Search,
    Listbox,
    ListboxOptions,
    ListboxOption,
    X
  },
  props: {
    data: {
      default: [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  emits: ["updated", "deleted", "submitted"],

  data() {
    return {
      show_results: false,
      search_term: "",
      search_results: [],
      selected_item: null,
      selected_items: []
    }
  },
  watch: {
    selected_item() {
      if (this.selected_item) {
        this.selected_items.push(this.selected_item)
        this.$emit("updated", this.selected_items)
        this.selected_item = null
        this.show_results = false
      }
    }
  },
  created() {
    this.selected_items = this.value
    this.search_results = this.data
  },

  methods: {
    handleDelete(item) {
      this.$emit("deleted", item)
    },
    handleKeyDown(e) {
      if (e.key === "Enter" && this.search_term) {
        this.$emit("submitted", this.search_term)
        this.search_term = ""
        this.show_results = false
      }
    },
    deselectItem(i) {
      this.selected_items.splice(i, 1)
      this.$emit("updated", this.selected_items)
    }
  }
}
</script>

<style scoped lang="postcss">
.mh-48 {
  max-height: 10rem;
}

.ghost {
  @apply bg-blue opacity-100 rounded-md w-full;
}
.chosen {
  @apply bg-blue opacity-50 rounded-md;
}
.chosen .line {
  opacity: 0;
}
</style>
